import uniqueId from 'lodash/uniqueId';

import { AIMessage, ContentPart, Message } from '../types/chat';

// Pure function to append a content part to message
export function appendPartToMessages(prev: Message[], part: ContentPart): Message[] {
  const next = [...prev];
  const last = next.at(-1);
  const now = new Date().toISOString();
  if (!last || last.sender !== 'ai') {
    const ai: AIMessage = {
      id: uniqueId(),
      sender: 'ai',
      timestamp: now,
      content: [part]
    };
    next.push(ai);
    return next;
  }
  const ai = { ...last } as AIMessage;
  ai.content = [...ai.content, part];
  next[next.length - 1] = ai;
  return next;
}
